import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'

export default function LogisticsQuoteAddressComponent ({quoteDetails }: any) {

  return (
    <>
<AccordionContainer
    child={
      
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <div>
        <InputLabelContainer 
        label="Building" 
        />
        <InputLabelContainer 
        label={quoteDetails?.start?.location?.address?.building}
        /></div>
    <div>
          <InputLabelContainer
              label="Locality"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.location?.address?.locality}
          /></div>
       <div>
          <InputLabelContainer
              label="City"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.location?.address?.city}
          /></div>
       <div>
          <InputLabelContainer
              label="Country"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.location?.address?.country}
          /></div>
       <div>
          <InputLabelContainer
              label="state"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.location?.address?.state}
          /></div>
       <div>
          <InputLabelContainer
              label="Area Code"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.location?.address?.area_code}
          /></div>
        <div>
          <InputLabelContainer
              label="Contact Number"
          />
          <InputLabelContainer
              label={quoteDetails?.start?.contact?.phone}
          />
       </div>
       </div>
  }
  expandedPanel="fromAddress"
  headerTitle="From Address"
/>
<AccordionContainer
    child={
      
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <div>
        <InputLabelContainer label="Building" />
        <InputLabelContainer label={quoteDetails?.end?.location?.address?.building}/>
    </div>
       <div>
          <InputLabelContainer
              label="Locality"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.location?.address?.locality}
          />
        </div>
      <div>
          <InputLabelContainer
              label="City"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.location?.address?.city}
          />
       </div>
        <div>
          <InputLabelContainer
              label="Country"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.location?.address?.country}
          />
        </div>
        <div>
          <InputLabelContainer
              label="state"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.location?.address?.state}
          />
        </div>
        <div>
          <InputLabelContainer
              label="Area Code"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.location?.address?.area_code}
          />
        </div>
       <div>
          <InputLabelContainer
              label="contact Phone Number"
          />
          <InputLabelContainer
              label={quoteDetails?.end?.contact?.phone}
          />
        </div>
        </div>
  }
  expandedPanel="toAddress"
  headerTitle="To Address"
/>
    
        </>
  )
}